import { BaseEntity } from ".";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class SchematicEntity extends BaseEntity {
  private _pin_info: any;
  constructor(id: number, props: any, pin_info: any) {
    super(id, props);
    this._dataTypeName = "PI Schematic";
    this._pin_info = pin_info;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    //const id = this._id;
    const props = this.props;
    const pin_info = this._pin_info;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      let name = "Unknown output";
      if (props.length) {
        const output = props.find((x: any) => x.isInput === 0);
        const outputType = await getCachedTypeEntity(output.typeID);
        if (outputType !== null) {
          name = outputType.props.name;
          entity.properties["output"] = {
            type: Excel.CellValueType.entity,
            text: outputType.props.name + " x " + output.quantity,
            properties: {
              quantity: {
                type: Excel.CellValueType.double,
                basicValue: output.quantity,
              },
              type: await outputType.toJson(),
            },
          };
        }
        const input = props.filter((x: any) => x.isInput === 1);
        let input_array: Excel.CellValue[][] = [];
        for (var i = 0; i < input.length; i++) {
          const inputType = await getCachedTypeEntity(input[i].typeID);
          if (inputType !== null) {
            const resolvedEntity = await inputType.toJson();
            input_array.push([
              {
                type: Excel.CellValueType.entity,
                text: inputType.props.name + " x " + input[i].quantity,
                properties: {
                  quantity: {
                    type: Excel.CellValueType.double,
                    basicValue: input[i].quantity,
                  },
                  type: resolvedEntity,
                },
              },
            ]);
          }
        }
        if (input_array.length) {
          entity.properties["input"] = {
            type: Excel.CellValueType.array,
            elements: input_array,
          };
        }
        if (pin_info) {
          let pin_array: Excel.CellValue[][] = [];
          for (var z = 0; z < pin_info.length; z++) {
            const pinEntity = await getCachedTypeEntity(pin_info[z].pinTypeID);
            if (pinEntity !== null) {
              pin_array.push([
                {
                  type: Excel.CellValueType.entity,
                  text: pinEntity.props.name,
                  properties: {
                    name: pinEntity.props.name,
                    type: await pinEntity.toJson(),
                  },
                },
              ]);
            }
          }
          if (pin_array.length) {
            entity.properties["pin_eligible"] = {
              type: Excel.CellValueType.array,
              elements: pin_array,
            };
          }
        }
      }
      entity.text = name + " schematic";
    }

    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
        //mainImage: { property: "image" },
      },
    };

    return entity;
  }
}
